import React from 'react';
import { Link } from 'react-router5';
import { BaseLinkProps } from 'react-router5/types/BaseLink';
import styled from '@emotion/styled';

const Root = styled(Link)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
`;

type LinkControlProps = Omit<BaseLinkProps, 'router'> & {
  noHrefForPageToRender?: boolean;
};

export const LinkPageItem: React.FC<LinkControlProps> = props => {
  const { children, noHrefForPageToRender, ...linkProps } = props;

  return <>{noHrefForPageToRender ? <>{children}</> : <Root {...linkProps}>{children}</Root>}</>;
};
